import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../authentication.service';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private language_cd: any = 'HIN'
  private translations: any = {
    ENG: {
      common: {
        back: 'Back',
        status: 'Status',
        yes: 'Yes',
        no: 'No',
        errorTitle: 'Error',
        successTitle: 'Success',
        oopsTitle: 'Oops !!',
        na: 'N/A',
        somethingWentWrong: 'Something went wrong.',
        update: 'Update',
        upload: 'Upload',
        filter: 'Filter',
        clear: 'Clear',
        overview: 'Overview',
        id: 'ID',
        daysOpen: 'Days Open',
        perPage: 'Per page',
        showing: 'Showing',
        of: 'of',
        action: 'Action',
        viewMore: 'View More',
        moreOptions: 'More options',
        recordsNotFound: 'Records not found!!',
        days: 'days',
        delete: 'Delete',
        cancel: 'Cancel',
        areYouSure: 'Are you sure?',
        warning: 'Warning',
        yesDeleteIt: 'Yes, Delete it!',
        deletedSuccessfully: 'Deleted Successfully',
        createdSuccessfully: 'Created Successfully',
        updatedSuccessfully: 'Updated Successfully',
        errorWhileCreating: 'Error While Creating',
        errorWhileUpdating: 'Error While Updating',
        pleaseFillAllFields: 'Please Enter All * Mandatory Details',
        duplicateEntry: 'This Record Already Exists',
        spaceNotAllowed: 'Space are not Allowed!',
        submit: 'Submit',
        save: 'Save',
        fromDate: 'From Date',
        toDate: 'To Date',
        search: 'Search',
        pdf: 'PDF'
      },
      export: {
        srNo: 'Sr.No.',
        ticketId: 'Ticket Id',
        department: 'Department',
        zone: 'Zone',
        fullName: 'Full Name',
        mobileNo: 'Mobile No.',
        complaintDate: 'Complaint Date',
        status: 'Status',
        ward: 'Ward',
        daysOpen: 'Days Open'
      },

      header: {
        selectLanguage: 'Select Language',
        profile: 'Profile',
        logout: 'Logout',
        title: 'Samadhan Divas Portal',
        subtitle: 'Nagar Nigam Lucknow Uttar Pradesh'
      },
      home: {
        welcome: 'Welcome, Welcome to Samadhan Diwas Portal'
      },
      preview: {
        ticketId: 'Ticket Id',
        fullName: 'Full Name',
        mobileNo: 'Mobile No.',
        complaintDepartment: 'Complaint Department',
        complaintType: 'Complaint Type',
        complaintDescription: 'Complaint Description',
        zone: 'Zone',
        ward: 'Ward',
        mohalla: 'Mohalla',
        uploadedDocument: 'Uploaded Document',
        otherDocument: 'Other Document',
        instantResolutionDetails: 'Instant Resolution Details',
        isInstantResolved: 'Is Instant Resolved',
        remark: 'Remark',
        approvalDescription: 'Approval Description',
        othersDetails: 'Others Details',
        name: 'Name',
        date: 'Date',
        document: 'Document',
        update: 'Update',
        printForm: 'Print Form',
        printFormTitle: 'Print form as PDF',
        registeredBy: 'Registered by',
        pendingAt: 'Pending at',
        closedBy: 'Closed by',
        resolvedBy: 'Resolved by',
        noDocumentUploaded: 'No document Uploaded !',
        uploadSuccess: 'Upload Successfully',
        uploadFailed: 'Unable to process your request'
      },
      operatorDashboard: {
        title: 'Dashboard',
        totalComplaintRegistered: 'Total Complaint Registered',
        addNewComplaints: 'Add New Complaints',
        recentComplaints: 'Recent Complaints',
        searchPlaceholder: 'Search',
        srNo: 'Sr. No.',
        ticketId: 'Ticket Id',
        department: 'Department',
        zone: 'Zone',
        ward: 'Ward',
        createDate: 'Complaint Date',
        daysOpen: 'Days Open',
        action: 'Action',
        viewMore: 'View More',
        viewDetailedInfo: 'View detailed information',
        moreOptions: 'More options',
        printForm: 'Print Form',
        fullName: 'Full Name',
        mobileNo: 'Mobile No'
      },
      operatorComplaint: {
        totalComplaints: 'Total Complaints',
        searchPlaceholder: 'Search complaints...',
        addNewComplaints: 'Add New Complaints',
        export: 'Export',
        srNo: 'Sr.No.',
        ticketId: 'Ticket Id',
        department: 'Department',
        zone: 'Zone',
        ward: 'Ward',
        createDate: 'Complaint Date',
        daysOpen: 'Days Open',
        status: 'Status',
        action: 'Action',
        viewMore: 'View More',
        printForm: 'Print Form',
        showing: 'Showing',
        of: 'of',
        departments: 'departments',
        perPage: 'Per page:',
        viewDetailedInfo: 'View detailed information',
        printFormTitle: 'Print Complaint Form',
        fullName: 'Full Name',
        mobileNo: 'Mobile No'
      },
      operatorNewComplaint: {
        back: 'Back',
        submitComplaintTitle: 'Submit a Complaint',
        instruction: 'Please fill out the form below with details about your complaint. Our team will review and address your concern promptly.',
        fullName: 'Full Name',
        enterFullName: 'Enter Full Name',
        fullNameRequired: 'Full Name is required',
        fullNameInvalid: 'Name cannot start with a space or contain numbers/special characters',
        fullNameMax: 'Full Name cannot exceed 250 characters',
        mobileNumber: 'Mobile Number',
        enterMobileNo: 'Enter Mobile No.',
        mobileInvalid: 'Please enter a valid 10 digits mobile number.',
        complaintDepartment: 'Complaint Department',
        selectDepartment: 'Select Department',
        departmentRequired: 'Department is required',
        complaintType: 'Complaint Type',
        selectComplaintType: 'Select Complaint Type',
        complaintTypeRequired: 'Complaint Type is required',
        enterComplaintType: 'Enter Complaint Type',
        complaintTypeNoLeadingSpace: 'Complaint Type cannot start with space',
        complaintDescription: 'Complaint Description',
        characters: 'characters',
        complaintDescriptionPlaceholder: 'Please describe your complaint in detail',
        descriptionRequired: 'Description is required',
        descriptionMax: 'Description cannot exceed 500 characters',
        descriptionNoLeadingSpace: 'Description cannot start with space',
        zone: 'Zone',
        select: 'Select',
        zoneRequired: 'Zone is required',
        ward: 'Ward',
        firstSelectWard: 'First select the Ward',
        wardRequired: 'Ward is required',
        officerName: 'Officer Name',
        officerRequired: 'Officer Name is required',
        uploadDocumentOptional: 'Upload Document (optional)',
        clickHereToView: 'click here to view',
        uploadNote: 'Upload 1 or more images related to your complaint (Max size: 5MB)',
        otherDocumentOptional: 'Other Document (optional)',
        maxSize: '(Max size: 5MB)',
        instantResolutionDetails: 'Instant Resolution Details',
        markResolvedInstantly: 'Mark as Resolved Instantly',
        instantResolveNote1: 'Check this if the complaint has been resolved immediately by the authority. Otherwise, it will be scheduled for resolution within',
        hours: 'hours',
        days: 'days',
        remark: 'Remark',
        remarkPlaceholder: 'Please provide your remarks',
        remarkRequired: 'Remark is required',
        remarkMax: 'Remark cannot exceed 500 characters',
        remarkNoLeadingSpace: 'Remark cannot start with space',
        approvalDescription: 'Approval Description',
        approvalRequired: 'Approval Description is required',
        approvalMax: 'Approval Description cannot exceed 500 characters',
        approvalNoLeadingSpace: 'Approval Description cannot start with space',
        uploadImageOrDocumentOptional: 'Upload Image or Document (optional)',
        submitComplaint: 'Submit Complaint',
        fillRequiredFields: 'Please fill all required fields.',
        markAtLeastOneDepartment: 'Mark at least one Department',
        noOfficerMapped: 'Not any Officer map in this Derpartment or zone',
        wardNotMapped: 'Ward is not map',
        mohallaNotMapped: 'Mohalla is not map',
        noDocumentUploaded: 'No document Uploaded !'
      },
      operatorSuccessModal: {
        resolvedTitle: 'Complaint Resolved Successfully',
        resolvedText: 'The matter has been addressed, documented in our Records,and Supported with the relevant document.',
        registeredTitle: 'Complaint Registered Successfully',
        ticketNo: 'Ticket No.',
        registeredText: 'has been generated and forwarded to the concerned department and authority'
      },
      sidebar: {
        dashboard: 'Dashboard',
        operatorDashboard: 'Dashboard',
        officerDashboard: 'Dashboard',
        adminDashboard: 'Dashboard',
        mcDashboard: 'Dashboard',
        totalGrievance: 'Total Greviance',
        todayGrievance: 'Today Greviance',
        pendingComp: 'Pending Comp.',
        newComplaints: 'New Complaints',
        complaints: 'Complaints',
        resolvedComp: 'Resolved Comp.',
        closedComp: 'Closed Comp.',
        searchComplaints: 'Search Complaints',
        updateComplaints: 'Update Complaints',
        escalatedComplaints: 'Escalated Comp.',
        userManagement: 'User Management',
        depManagement: 'Dep. Management',
        escalationMatrix: 'Escalation Matrix',
        zoneWordMapping: 'Zone & Word Mapping',
        hierarchy: 'Hierarchy',
        roleManagement: 'Role Management'
      },
      footer: {
        copyright: '2024 © PCS Management Consultancy Pvt. Ltd. All rights reserved.',
        marquee: "For immediate assistance, please don't hesitate to reach out to our dedicated support team at 9918000241"
      },
      userProfile: {
        dashboard: 'Dashboard',
        personalInfo: 'Personal Info',
        establishmentInfo: 'Establishment Info',
        contactInfo: 'Contact Info',
        changePassword: 'Change Password',
        back: 'Back',
        partyName: 'Party Name',
        partyId: 'Party Id',
        empId: 'Emp Id',
        email: 'Email',
        mobileNo: 'Mobile No.',
        oldPassword: 'Old Password',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        uploadImage: 'Upload Image',
         updateProfile: 'Update Profile',
         instructions: 'Instructions',
         passwordInstruction1: 'Password must be at least 8 characters long.',
         passwordInstruction2: 'Password must contain at least 1 uppercase letter, 1 number, and 1 special character.',
         passwordInstruction3: 'Password should not contain your name, mobile number, or email address.',
         passwordInstruction4: 'New password cannot be the same as the Current password.',
         passwordInstruction5: 'Confirm password must match the new password.',
         reset: 'Reset'
       },
      adminDashboard: {
        title: 'Admin Dashboard',
        userManagement: 'User Management',
        userManagementDesc: 'Manage system users and permissions',
        departmentConfig: 'Department Config',
        departmentConfigDesc: 'Manage departments and categories',
        escalationMatrix: 'Escalation Matrix',
        escalationMatrixDesc: 'Configure complaint escalation rules',
        zoneSetup: 'Zone & Setup',
        zoneSetupDesc: 'Manage geographical zones and wards',
        totalComplaints: 'Total Complaints',
        filterComplaints: 'Filter Complaints',
        complaintsOverview: 'Complaints Overview',
        acrossAllDept: 'Across all department',
        selectDepartment: 'Select Department',
        allZones: 'All Zones',
        allStatuses: 'All Statuses',
        allDates: 'All Dates',
        clearFilter: 'Clear Filter',
        searchPlaceholder: 'Search complaints...',
        fullName: 'Full Name',
        mobileNo: 'Mobile No'
      },
      officerDashboard: {
        title: 'Dashboard',
        totalComplaints: 'Total Complaints',
        pending: 'Pending',
        resolved: 'Resolved',
        escalated: 'Escalated',
        awaitingAction: 'Awaiting Action',
        successfullyCompleted: 'Successfully Completed',
        elevatedToHigherLevel: 'Elevated to higher level',
        forYourDepartment: 'For your Department',
        search: 'Search',
        srNo: 'Sr.No.',
        ticketId: 'Ticket Id',
        department: 'Department',
        createdDate: 'Created Date',
        recordsNotFound: 'Records Not Found!!',
        fullName: 'Full Name',
        mobileNo: 'Mobile No'
      },
      mcDashboard: {
        title: 'Municipal Commissioner Dashboard',
        subtitle: 'Grievance Redressal System-Executive Overview',
        totalGrievances: 'Total Grievances',
        pending: 'Pending',
        resolved: 'Resolved',
        closed: 'Closed',
        escalated: 'Escalated',
        todayRegistered: 'Today Registered',
        deptPerformance: 'Department-Wise Performance',
        resolutionRate: 'Resolution Rate',
        averageTime: 'Average Time',
        wiseGrievanceDistribution: '-Wise Grievance Distribution',
        escalatedTracker: 'Escalated Complaints Tracker',
        generated: 'Generated',
        assignedOfficer: 'Assigned Officer',
        daysPending: 'Days Pending',
        escalatedComplaintsLower: 'escalated complaints',
        total: 'Total',
        ward: 'Ward',
        zone: 'Zone',
        department: 'Department',
        recordsNotFound: 'Records Not Found!!'
      },
      adminDepManagement: {
        title: 'Department Management',
        addNewDepartment: 'Add New Department',
        allDepartments: 'All Departments',
        searchPlaceholder: 'Search Departments...',
        srNo: 'Sr. No.',
        departmentName: 'Department Name',
        code: 'Code',
        complaintTypes: 'Complaint Types',
        status: 'Status',
        actions: 'Actions',
        active: 'Active',
        perPage: 'Per page:',
        backToList: 'Back to List',
        editDepartment: 'Edit Department',
        updateDetails: 'Update the details of the department.',
        enterDetails: 'Enter department details to create a new department.',
        enterDepartmentName: 'Enter Department Name',
        departmentCode: 'Department Code',
        enterDepartmentCode: 'Enter Department Code',
        activeStatus: 'Active Status',
        enterComplaintTypeName: 'Enter Complaint Type Name',
        enterCode: 'Enter Code',
        add: 'Add',
        updateDepartment: 'Update Department',
        addDepartment: 'Add Department',
        showing: 'Showing',
        departments: 'departments',
        duplicateCodeTitle: 'Duplicate Code',
        duplicateCodeMsg: 'This complaint type code already exists.',
        requiredTitle: 'Required',
        requiredMsg: 'Both Complaint Type Name and Code are required.',
        fillRequiredFields: 'Please fill all required fields.',
        departmentCodeExists: 'This department code already exists.',
        areYouSure: 'Are you Sure !!',
        cantRetrieve: "After update you can't retrieve it?",
        deleteConfirmText: "After delete you can't retrieve it?",
        departmentCodeRequired: 'Department Code is required.',
        departmentNameRequired: 'Department Name is required.',
        search: 'Search',
        cancel: 'Cancel',
        next: 'Next',
        back: 'Back'
      },
      adminEscalationMatrix: {
        title: 'Escalation Matrix',
        addRule: 'Add Rule',
        escalationRules: 'Escalation Rules',
        searchPlaceholder: 'Search Escalation time...',
        srNo: 'Sr. No.',
        escalationTime: 'Escalation Time (hrs)',
        actions: 'Actions',
        showing: 'Showing',
        rules: 'rules',
        perPage: 'Per page',
        addNewRuleTitle: 'Add New Escalation Rule',
        addNewRuleDesc: 'Enter escalation rule details to create a new entry.',
        enterTimePlaceholder: 'Enter Time',
        cancel: 'Cancel',
        addRuleBtn: 'Add Rule',
        updateRuleBtn: 'Update Rule',
        atLeastOneRule: 'At least One Rule is Required',
        deleteConfirmText: "After delete you can't retrieve it?",
        updateConfirmText: "After update you can't retrieve it?"
      },
      adminHierarchy: {
        title: 'Organization Hierarchy',
        hierarchyList: 'Hierarchy List',
        createHierarchy: 'Create Hierarchy',
        updateHierarchy: 'Update Hierarchy',
        searchPlaceholder: 'Search',
        createHierarchyNode: 'Create Hierarchy Node',
        nodeType: 'Node Type',
        systemCode: 'System Code',
        userCode: 'User Code',
        value: 'Value',
        sdp: 'SDP',
        level1Code: 'Level 1 Code',
        level1Value: 'Level 1 Value',
        level2Code: 'Level 2 Code',
        level2Value: 'Level 2 Value',
        level3Code: 'Level 3 Code',
        level3Value: 'Level 3 Value',
        level4Code: 'Level 4 Code',
        level4Value: 'Level 4 Value',
        level5Code: 'Level 5 Code',
        level5Value: 'Level 5 Value',
        level6Code: 'Level 6 Code',
        level6Value: 'Level 6 Value',
        level7Code: 'Level 7 Code',
        level7Value: 'Level 7 Value',
        leafCode: 'Leaf Code',
        leafValue: 'Leaf Value',
        selectNode: 'Select Node',
        level: 'Level',
        selectNodePlaceholder: 'Select Node',
        currentNodePath: 'Current Node Path',
        selectNodeType: 'Select Node Type',
        selectNodeTypePlaceholder: 'Select Node Type',
        nodeCode: 'Node Code',
        enterNodeCode: 'Enter Node Code',
        nodeDescription: 'Node Description',
        enterNodeDescription: 'Enter Node Description',
        submit: 'Submit',
        update: 'Update',
        loading: 'Loading...',
        selectUptoCostCenter: 'You Must Select Upto Cost Center',
        actionNotForUpdate: 'This Action Can Not Be Perform For Update',
        statusChangedInactive: 'Successfully Status Changed To Inactive',
        nodeLastLevel: 'You Have Not Selected Node At The Last Level',
        nodeCodeExists: 'This Node Code Is Already Exists',
        deleteNodeConfirm: 'If You Delete This Node Then All Nodes Below This Node Will Be Deleted...!',
        level1NodeType: 'Level 1 Node Type',
        level2NodeType: 'Level 2 Node Type',
        level3NodeType: 'Level 3 Node Type',
        level4NodeType: 'Level 4 Node Type',
        level5NodeType: 'Level 5 Node Type',
        level6NodeType: 'Level 6 Node Type',
        level7NodeType: 'Level 7 Node Type',
        isLeaf: 'Is Leaf',
        leafSystemCode: 'Leaf System Code',
        leafNodeType: 'Leaf Node Type',
        action: 'Action'
      },
      adminRole: {
        title: 'Role',
        roleList: 'Role List',
        createRole: 'Create Role',
        updateRole: 'Update Role',
        searchPlaceholder: 'Search',
        create: 'Create',
        roleCode: 'Role Code',
        roleName: 'Role Name',
        roleDescription: 'Role Description',
        roleType: 'Role Type',
        resource: 'Resource',
        action: 'Action',
        enterRoleCode: 'Enter Role Code',
        enterRoleName: 'Enter Role Name',
        enterRoleDescription: 'Enter Role Description',
        selectResource: 'Select Resource',
        selectAllResource: 'Select All Resource',
        submit: 'Submit',
        update: 'Update'
      },
      adminUser: {
        title: 'Users',
        userList: 'User List',
        createUser: 'Create User',
        filterPlaceholder: 'Filter',
        mapUser: 'Map User',
        userId: 'User ID',
        userName: 'User Name',
        phoneNo: 'Phone No',
        email: 'Email',
        roleDescription: 'Role Description',
        action: 'Action',
        delete: 'Delete',
        openList: 'Open List',
        selectUser: 'Select User :',
        selectRole: 'Select Role :',
        submit: 'Submit',
        enterEmail: 'Enter Email :',
        enterPassword: 'Enter Password :',
        enterConfirmPassword: 'Confirm Password :',
        selectUserPlaceholder: 'Select User',
        selectRolePlaceholder: 'Select Role',
        enterEmailPlaceholder: 'Enter Email',
        enterPasswordPlaceholder: 'Enter Password',
        enterConfirmPasswordPlaceholder: 'Confirm Password',
        enterPhoneNumber: 'Enter Phone Number :',
        enterPhoneNumberPlaceholder: 'Enter Phone Number',
        update: 'Update',
        allRoles: 'All Roles',
        sNo: 'S.No.',
        close: 'Close',
        enterValidMobile: 'Please enter valid mobile number',
        mobileRecordNotFound: 'Record not found for this mobile number',
        selectRoleError: 'Please Select Role',
        userAlreadyExists: 'This User Already Exists.',
        errorWhileGettingLE: 'Error while getting current Legal Entity'
      },
      adminUserManagement: {
        title: 'User Management',
        backToList: 'Back to List',
        addNewUser: 'Add New User',
        createEmployee: 'Create Employee',
        updateEmployeeId: 'Update Employee ID',
        selectEmployeeActiveStatus: 'Select Employee Active Status',
        searchPlaceholder: 'Search',
        srNo: 'Sr. No.',
        name: 'Name',
        role: 'Role',
        contact: 'Contact',
        department: 'Department',
        status: 'Status',
        actions: 'Actions',
        active: 'Active',
        inactive: 'Inactive',
        allUsers: 'All Users',
        searchUsers: 'Search Users...',
        viewMore: 'View More',
        organization: 'Organization',
        employeeDetails: 'Employee Details',
        employeeDetailsSubtitle: 'Full information about the employee',
        employeeName: 'Employee Name',
        phoneNumber: 'Phone Number',
        dob: 'Date of Birth',
        showing: 'Showing',
        users: 'Users',
        of: 'of',
        enterMobile: 'Enter Mobile Number:',
        search: 'Search',
        cancel: 'Cancel',
        next: 'Next',
        back: 'Back',
        identity: 'Identity',
        personInfo: 'Person Info',
        personId: 'Person Id:',
        systemAssigned: 'system assigned',
        personName: 'Person Name:',
        personNameRequired: 'Person name is required',
        email: 'Email:',
        emailRequired: 'Email is required',
        validEmail: 'Email Is Valid',
        enterValidEmail: 'Enter Valid Email',
        phone: 'Phone:',
        phoneRequired: 'Phone number is required',
        personDob: 'Person DOB:',
        dobRequired: 'Date of birth is required',
        assignment: 'Assignment',
        employeeInfo: 'Employee Info',
        employeeId: 'Employee Id',
        enterEmployeeId: 'Enter Employee Id',
        employeeIdRequired: 'Employee ID is required',
        selectRole: 'Select Role',
        roleRequired: 'Role selection is required',
        selectDepartment: 'Select Department',
        departmentRequired: 'Department is required',
        functionalArea: 'Functional Area',
        functionalAreaRequired: 'Functional area is required',
        selectHierarchy: 'Select Organizational Hierarchy',
        selectHierarchyBtn: 'Select Hierarchy',
        hierarchyRequired: 'Select Hierarchy is required',
        selectedHierarchyPath: 'Selected Hierarchy Path:',
        done: 'Done',
        selectedRole: 'Selected Role:',
        selectedDepartment: 'Selected Department:',
        submit: 'Submit',
        currentlyEmployeeId: 'Currently Employee Id:',
        newEmployeeId: 'New Employee Id:',
        enterNewEmployeeId: 'Enter New Employee Id',
         info: 'Info',
         duplicateEmployeeError: 'An employee with searched email or phone no. already exists, Please search with a different email and phone no. to add a new employee.',
         userName: 'User Name',
         organizationHierarchy: 'Organization Hierarchy',
         assign: 'Assign',
         close: 'Close',
         instructions: 'Instructions',
         instruction1: 'Select the hierarchy levels from the dropdowns.',
         instruction2: 'Click on the down arrow button to add a new level below the current level.',
         instruction3: 'Click on the up arrow button to remove the current level from the hierarchy.',
         instruction4: 'If Employee is Working in multiple zones or wards then select one Zone and one ward. After the add Employee assign multiple zones or wards go through the list and Edit',
         instruction5: 'If Employee is Working in multiple zones or wards add through assign button.',
         currentHierarchyPath: 'Current Hierarchy Path :',
         select: 'Select :',
         level: 'Level',
         warning: 'Warning',
         fieldsCannotBeEmpty: 'Fields cannot be Empty',
         fieldsCannotBeNull: 'Fields cannot be null',
         mobileOrEmailNull: 'Mobile Number or Email can not be null',
         invalidEmail: 'Invalid Email',
         mobileTenDigit: 'Mobile Number in 10 digit',
         enterValidCredential: 'Please Enter Valid Credential',
         enterValidLegalEntity: 'Please Enter Valid Legal Entity Not Org..',
         personExistsWarning: 'A person with searched email/phone number is already available. Following are the details for this person. If you want to add this person as employee then you can continue by clcking "next". If this is not the person that you wanted to add then please click "Back" and search using different phone and/or email.',
         noPersonFoundInfo: 'No person found with searched email/phone in the system. Please fill the details to create identity for the employee that you want to add',
         inactiveSuccess: 'Inactive Successfully',
         activeSuccess: 'Active Successfully',
         incorrectPhone: '...Incorrect Phone Number....!',
         areYouSure: 'Are you sure?',
         yesAddIt: 'Yes, Add it!',
         selectTwoLevel: 'Please Select at least two level',
         empIdNotNull: 'Emp-ID Should Not Be Null!',
         empIdUpdated: 'Employee ID Updated..!',
         assignmentUpdated: 'Assignment Detail Updated..!'
      },
      adminZoneWordMapping: {
        title: 'Zone and Ward Mapping',
        addNewWard: 'Add New Ward',
        addWardByExcel: 'Add Ward by Excel',
        backToList: 'Back to List',
        wardMapping: 'Ward Mapping',
        searchPlaceholder: 'Search Ward',
        zone: 'Zone',
        ward: 'Ward',
        mohalla: 'Mohalla',
        actions: 'Actions'
      },
      officerComplaints: {
        closedTitle: 'Closed Complaints',
        escalatedTitle: 'Escalated Complaints',
        pendingTitle: 'Pending Complaints',
        resolvedTitle: 'Resolved Complaints',
        searchPlaceholder: 'Search',
        excel: 'Excel',
        pdf: 'PDF',
        exportToExcel: 'Export to Excel',
        exportToPDF: 'Export to PDF',
        srNo: 'Sr.No.',
        ticketId: 'Ticket Id',
        department: 'Department',
        createdDate: 'Created Date',
        zone: 'Zone',
        daysOpen: 'Days Open',
        status: 'Status',
        action: 'Action',
        viewMore: 'View More',
        printForm: 'Print Form',
        fullName: 'Full Name',
        mobileNo: 'Mobile No'
      },
      mcComplaints: {
        pendingTitle: 'Pending Complaints',
        todayRegisteredTitle: 'Today Registered',
        totalTitle: 'Total Complaints',
        searchPlaceholder: 'Search',
        excel: 'Excel',
        pdf: 'PDF',
        exportToExcel: 'Export to Excel',
        exportToPDF: 'Export to PDF',
        srNo: 'Sr.No.',
        ticketId: 'Ticket Id',
        department: 'Department',
        createdDate: 'Created Date',
        zone: 'Zone',
        daysOpen: 'Days Open',
        status: 'Status',
        action: 'Action',
        viewMore: 'View More',
        printForm: 'Print Form',
        recordsNotFound: 'Records not found!!',
        fullName: 'Full Name',
        mobileNo: 'Mobile No'
      },
      officerSearchComplaints: {
        title: 'Complaints',
        searchPlaceholder: 'Search',
        id: 'ID',
        department: 'Department',
        dateTime: 'Date & Time',
        zone: 'Zone'
      },
      officerUpdateComplaints: {
        back: 'Back',
        ticketId: 'Ticket Id',
        filledOn: 'Filled On',
        updateStatus: 'Update Status',
        complaintsDetails: 'Complaints Details',
        complaintsInformation: 'Complaints Information',
        reportedBy: 'Details of the Complaints as reported by',
        description: 'Description',
        department: 'Department',
        zone: 'Zone',
        citizenInformation: 'Citizen Information',
        contactNumber: 'Contact Number',
        contactCitizen: 'Contact Citizen',
        updateComplaintTitle: 'Update Complaints Status',
        reviewInstruction: 'Review the complaints and update its status, or escalate if needed.',
        remarksActionTaken: 'Remarks/Action Taken',
        uploadSupportingDoc: 'Upload Supporting Document (optional)',
        clickHereToView: 'click here to view',
        updateComplaintBtn: 'Update Complaint',
        fillRequired: 'Fill All Required fields',
        resolved: 'RESOLVED',
        closed: 'CLOSED'
      }
    },
    HIN: {
      common: {
        back: 'वापस',
        status: 'स्थिति',
        yes: 'हां',
        no: 'नहीं',
        errorTitle: 'त्रुटि',
        successTitle: 'सफल',
        oopsTitle: 'क्षमा करें',
        na: 'उपलब्ध नहीं',
        somethingWentWrong: 'कुछ गलत हो गया',
        update: 'अपडेट',
        upload: 'अपलोड',
        filter: 'फ़िल्टर',
        clear: 'रीसेट करें',
        overview: 'अवलोकन',
        id: 'आईडी',
        daysOpen: 'दिन खुले',
        perPage: 'प्रति पृष्ठ',
        showing: 'दिखा रहा है',
        of: 'में से',
        action: 'कार्रवाई',
        viewMore: 'और देखें',
        moreOptions: 'अधिक विकल्प',
        recordsNotFound: 'रिकॉर्ड नहीं मिला !!',
        days: 'दिन',
        delete: 'हटाएं',
        cancel: 'रद्द करें',
        areYouSure: 'क्या आप सुनिश्चित हैं?',
        warning: 'चेतावनी',
        yesDeleteIt: 'हां, इसे हटा दें!',
        deletedSuccessfully: 'सफलतापूर्वक हटाया गया',
        createdSuccessfully: 'सफलतापूर्वक बनाया गया',
        updatedSuccessfully: 'सफलतापूर्वक अपडेट किया गया',
        errorWhileCreating: 'बनाने में त्रुटि',
        errorWhileUpdating: 'अपडेट करने में त्रुटि',
        pleaseFillAllFields: 'कृपया सभी * अनिवार्य विवरण दर्ज करें',
        duplicateEntry: 'यह रिकॉर्ड पहले से मौजूद है',
        spaceNotAllowed: 'स्पेस की अनुमति नहीं है!',
        submit: 'जमा करें',
        save: 'सहेजें',
        fromDate: 'दिनांक से',
        toDate: 'दिनांक तक',
        search: 'खोजें',
        pdf: 'पीडीएफ'
      },
      export: {
        srNo: 'क्रम सं.',
        ticketId: 'टिकट आईडी',
        department: 'विभाग',
        zone: 'जोन',
        fullName: 'पूरा नाम',
        mobileNo: 'मोबाइल नंबर',
        complaintDate: 'शिकायत तिथि',
        status: 'स्थिति',
        ward: 'वार्ड',
        daysOpen: 'दिन खुले'
      },
      operatorComplaint: {
        totalComplaints: 'कुल शिकायतें',
        searchPlaceholder: 'शिकायतें खोजें...',
        addNewComplaints: 'नई शिकायत जोड़ें',
        export: 'निर्यात',
        srNo: 'क्रम सं.',
        ticketId: 'टिकट आईडी',
        department: 'विभाग',
        zone: 'जोन',
        ward: 'वार्ड',
        createDate: 'शिकायत तिथि',
        daysOpen: 'दिन खुले',
        status: 'स्थिति',
        action: 'कार्रवाई',
        viewMore: 'और देखें',
        printForm: 'फॉर्म प्रिंट करें',
        showing: 'दिखा रहे हैं',
        of: 'में से',
        departments: 'विभाग',
        perPage: 'प्रति पृष्ठ:',
        viewDetailedInfo: 'विस्तृत जानकारी देखें',
        printFormTitle: 'शिकायत फॉर्म प्रिंट करें',
        fullName: 'पूरा नाम',
        mobileNo: 'मोबाइल नंबर'
      },
      header: {
        selectLanguage: 'भाषा चुनें',
        profile: 'प्रोफ़ाइल',
        logout: 'लॉग आउट',
        title: 'समाधान दिवस पोर्टल',
        subtitle: 'नगर निगम लखनऊ उत्तर प्रदेश'
      },
      sidebar: {
        dashboard: 'डैशबोर्ड',
        operatorDashboard: 'डैशबोर्ड',
        officerDashboard: 'डैशबोर्ड',
        adminDashboard: 'डैशबोर्ड',
        mcDashboard: 'डैशबोर्ड',
        totalGrievance: 'कुल शिकायतें',
        todayGrievance: 'आज की शिकायतें',
        pendingComp: 'लंबित शिकायतें',
        newComplaints: 'नई शिकायतें',
        complaints: 'शिकायतें',
        resolvedComp: 'निस्तारित शिकायतें',
        closedComp: 'बंद शिकायतें',
        searchComplaints: 'शिकायत खोजें',
        updateComplaints: 'शिकायत अपडेट करें',
        escalatedComplaints: 'एस्केलेटेड शिकायतें',
        userManagement: 'उपयोगकर्ता प्रबंधन',
        depManagement: 'विभाग प्रबंधन',
        escalationMatrix: 'एस्केलेशन मैट्रिक्स',
        zoneWordMapping: 'जोन और वार्ड मैपिंग',
        hierarchy: 'पदानुक्रम',
        roleManagement: 'भूमिका प्रबंधन'
      },
      footer: {
        copyright: '2024 © पीसीएस मैनेजमेंट कंसल्टेंसी प्रा. लि. सर्वाधिकार सुरक्षित।',
        marquee: 'तत्काल सहायता के लिए, कृपया हमारी समर्पित सहायता टीम से 9918000241 पर संपर्क करने में संकोच न करें'
      },
      userProfile: {
        dashboard: 'डैशबोर्ड',
        personalInfo: 'व्यक्तिगत जानकारी',
        establishmentInfo: 'स्थापना जानकारी',
        contactInfo: 'संपर्क जानकारी',
        changePassword: 'पासवर्ड बदलें',
        back: 'वापस',
        partyName: 'पार्टी का नाम',
        partyId: 'पार्टी आईडी',
        empId: 'कर्मचारी आईडी',
        email: 'ईमेल',
        mobileNo: 'मोबाइल नंबर',
        oldPassword: 'पुराना पासवर्ड',
        newPassword: 'नया पासवर्ड',
        confirmPassword: 'पासवर्ड की पुष्टि करें',
        uploadImage: 'छवि अपलोड करें',
         updateProfile: 'प्रोफ़ाइल अपडेट करें',
         instructions: 'निर्देश',
         passwordInstruction1: 'पासवर्ड कम से कम 8 वर्ण लंबा होना चाहिए।',
         passwordInstruction2: 'पासवर्ड में कम से कम 1 अपरकेस अक्षर, 1 नंबर और 1 विशेष वर्ण होना चाहिए।',
         passwordInstruction3: 'पासवर्ड में आपका नाम, मोबाइल नंबर या ईमेल पता नहीं होना चाहिए।',
         passwordInstruction4: 'नया पासवर्ड वर्तमान पासवर्ड के समान नहीं हो सकता।',
         passwordInstruction5: 'कन्फर्म पासवर्ड नए पासवर्ड से मेल खाना चाहिए।',
         reset: 'रीसेट'
       },
      adminDashboard: {
        title: 'एडमिन डैशबोर्ड',
        userManagement: 'उपयोगकर्ता प्रबंधन',
        userManagementDesc: 'सिस्टम उपयोगकर्ताओं और अनुमतियों का प्रबंधन करें',
        departmentConfig: 'विभाग कॉन्फ़िगरेशन',
        departmentConfigDesc: 'विभागों और श्रेणियों का प्रबंधन करें',
        escalationMatrix: 'एस्केलेशन मैट्रिक्स',
        escalationMatrixDesc: 'शिकायत एस्केलेशन नियम कॉन्फ़िगर करें',
        zoneSetup: 'जोन और सेटअप',
        zoneSetupDesc: 'भौगोलिक जोन और वार्ड का प्रबंधन करें',
        totalComplaints: 'कुल शिकायतें',
        filterComplaints: 'शिकायतें फ़िल्टर करें',
        complaintsOverview: 'शिकायत अवलोकन',
        acrossAllDept: 'सभी विभागों में',
        selectDepartment: 'विभाग चुनें',
        allZones: 'सभी जोन',
        allStatuses: 'सभी स्थितियाँ',
        allDates: 'सभी तारीखें',
        clearFilter: 'फ़िल्टर साफ़ करें',
        searchPlaceholder: 'शिकायतें खोजें...',
        fullName: 'पूरा नाम',
        mobileNo: 'मोबाइल नंबर'
      },
      mcDashboard: {
        title: 'नगर आयुक्त डैशबोर्ड',
        subtitle: 'शिकायत निवारण प्रणाली - कार्यकारी अवलोकन',
        totalGrievances: 'कुल शिकायतें',
        pending: 'लंबित',
        resolved: 'निस्तारित',
        closed: 'बंद',
        escalated: 'एस्केलेटेड',
        todayRegistered: 'आज पंजीकृत',
        deptPerformance: 'विभाग-वार प्रदर्शन',
        resolutionRate: 'निस्तारण दर',
        averageTime: 'औसत समय',
        wiseGrievanceDistribution: '-वार शिकायत वितरण',
        escalatedTracker: 'एस्केलेटेड शिकायत ट्रैकर',
        generated: 'जनरेट किया गया',
        assignedOfficer: 'नियुक्त अधिकारी',
        daysPending: 'लंबित दिन',
        escalatedComplaintsLower: 'एस्केलेटेड शिकायतें',
        total: 'कुल',
        ward: 'वार्ड',
        zone: 'जोन',
        department: 'विभाग',
        recordsNotFound: 'रिकॉर्ड नहीं मिला !!'
      },
      adminDepManagement: {
        title: 'विभाग प्रबंधन',
        addNewDepartment: 'नया विभाग जोड़ें',
        allDepartments: 'सभी विभाग',
        searchPlaceholder: 'विभाग खोजें...',
        srNo: 'क्रम सं.',
        departmentName: 'विभाग का नाम',
        code: 'कोड',
        complaintTypes: 'शिकायत के प्रकार',
        status: 'स्थिति',
        actions: 'कार्रवाई',
        active: 'सक्रिय',
        perPage: 'प्रति पृष्ठ:',
        backToList: 'सूची पर वापस जाएं',
        editDepartment: 'विभाग संपादित करें',
        updateDetails: 'विभाग का विवरण अपडेट करें।',
        enterDetails: 'नया विभाग बनाने के लिए विभाग का विवरण दर्ज करें।',
        enterDepartmentName: 'विभाग का नाम दर्ज करें',
        departmentCode: 'विभाग कोड',
        enterDepartmentCode: 'विभाग कोड दर्ज करें',
        activeStatus: 'सक्रिय स्थिति',
        enterComplaintTypeName: 'शिकायत प्रकार का नाम दर्ज करें',
        enterCode: 'कोड दर्ज करें',
        add: 'जोड़ें',
        updateDepartment: 'विभाग अपडेट करें',
        addDepartment: 'विभाग जोड़ें',
        showing: 'दिखा रहे हैं',
        departments: 'विभाग',
        duplicateCodeTitle: 'डुप्लिकेट कोड',
        duplicateCodeMsg: 'यह शिकायत प्रकार कोड पहले से मौजूद है।',
        requiredTitle: 'आवश्यक',
        requiredMsg: 'शिकायत प्रकार का नाम और कोड दोनों आवश्यक हैं।',
        fillRequiredFields: 'कृपया सभी आवश्यक फ़ील्ड भरें।',
        departmentCodeExists: 'यह विभाग कोड पहले से मौजूद है।',
        areYouSure: 'क्या आप सुनिश्चित हैं !!',
        cantRetrieve: "अपडेट करने के बाद आप इसे पुनर्प्राप्त नहीं कर सकते?",
        deleteConfirmText: "हटाने के बाद आप इसे पुनर्प्राप्त नहीं कर सकते?",
        departmentCodeRequired: 'विभाग कोड आवश्यक है।',
        departmentNameRequired: 'विभाग का नाम आवश्यक है।',
        search: 'खोजें',
        cancel: 'रद्द करें',
        next: 'अगला',
        back: 'वापस'
      },
      adminEscalationMatrix: {
        title: 'एस्केलेशन मैट्रिक्स',
        addRule: 'नियम जोड़ें',
        escalationRules: 'एस्केलेशन नियम',
        searchPlaceholder: 'एस्केलेशन समय खोजें...',
        srNo: 'क्रम सं.',
        escalationTime: 'एस्केलेशन समय (घंटे)',
        actions: 'कार्रवाई',
        showing: 'दिखा रहे हैं',
        rules: 'नियम',
        perPage: 'प्रति पृष्ठ',
        addNewRuleTitle: 'नया एस्केलेशन नियम जोड़ें',
        addNewRuleDesc: 'नई प्रविष्टि बनाने के लिए एस्केलेशन नियम विवरण दर्ज करें।',
        enterTimePlaceholder: 'समय दर्ज करें',
        cancel: 'रद्द करें',
        addRuleBtn: 'नियम जोड़ें',
        updateRuleBtn: 'नियम अपडेट करें',
        atLeastOneRule: 'कम से कम एक नियम आवश्यक है',
        deleteConfirmText: "हटाने के बाद आप इसे पुनर्प्राप्त नहीं कर सकते?",
        updateConfirmText: "अपडेट करने के बाद आप इसे पुनर्प्राप्त नहीं कर सकते?"
      },
      adminHierarchy: {
        title: 'संगठन पदानुक्रम',
        hierarchyList: 'पदानुक्रम सूची',
        createHierarchy: 'पदानुक्रम बनाएं',
        updateHierarchy: 'पदानुक्रम अपडेट करें',
        searchPlaceholder: 'खोजें',
        createHierarchyNode: 'पदानुक्रम नोड बनाएं',
        nodeType: 'नोड प्रकार',
        systemCode: 'सिस्टम कोड',
        userCode: 'उपयोगकर्ता कोड',
        value: 'मान',
        sdp: 'एसडीपी',
        level1Code: 'स्तर 1 कोड',
        level1Value: 'स्तर 1 मान',
        level2Code: 'स्तर 2 कोड',
        level2Value: 'स्तर 2 मान',
        level3Code: 'स्तर 3 कोड',
        level3Value: 'स्तर 3 मान',
        level4Code: 'स्तर 4 कोड',
        level4Value: 'स्तर 4 मान',
        level5Code: 'स्तर 5 कोड',
        level5Value: 'स्तर 5 मान',
        level6Code: 'स्तर 6 कोड',
        level6Value: 'स्तर 6 मान',
        level7Code: 'स्तर 7 कोड',
        level7Value: 'स्तर 7 मान',
        leafCode: 'लीफ़ कोड',
        leafValue: 'लीफ़ मान',
        selectNode: 'नोड चुनें',
        level: 'स्तर',
        selectNodePlaceholder: 'नोड चुनें',
        currentNodePath: 'वर्तमान नोड पथ',
        selectNodeType: 'नोड प्रकार चुनें',
        selectNodeTypePlaceholder: 'नोड प्रकार चुनें',
        nodeCode: 'नोड कोड',
        enterNodeCode: 'नोड कोड दर्ज करें',
        nodeDescription: 'नोड विवरण',
        enterNodeDescription: 'नोड विवरण दर्ज करें',
        submit: 'जमा करें',
        update: 'अपडेट करें',
        loading: 'लोड हो रहा है...',
        selectUptoCostCenter: 'आपको लागत केंद्र तक चयन करना होगा',
        actionNotForUpdate: 'यह कार्रवाई अपडेट के लिए नहीं की जा सकती',
        statusChangedInactive: 'सफलतापूर्वक स्थिति निष्क्रिय में बदल दी गई',
        nodeLastLevel: 'आपने अंतिम स्तर पर नोड का चयन नहीं किया है',
        nodeCodeExists: 'यह नोड कोड पहले से मौजूद है',
        deleteNodeConfirm: 'यदि आप इस नोड को हटाते हैं तो इस नोड के नीचे के सभी नोड हटा दिए जाएंगे...!',
        level1NodeType: 'स्तर 1 नोड प्रकार',
        level2NodeType: 'स्तर 2 नोड प्रकार',
        level3NodeType: 'स्तर 3 नोड प्रकार',
        level4NodeType: 'स्तर 4 नोड प्रकार',
        level5NodeType: 'स्तर 5 नोड प्रकार',
        level6NodeType: 'स्तर 6 नोड प्रकार',
        level7NodeType: 'स्तर 7 नोड प्रकार',
        isLeaf: 'Is Leaf',
        leafSystemCode: 'लीफ़ सिस्टम कोड',
        leafNodeType: 'लीफ़ नोड प्रकार',
        action: 'कार्रवाई'
      },
      adminRole: {
        title: 'भूमिका',
        roleList: 'भूमिका सूची',
        createRole: 'भूमिका बनाएं',
        updateRole: 'भूमिका अपडेट करें',
        searchPlaceholder: 'खोजें',
        create: 'बनाएं',
        roleCode: 'भूमिका कोड',
        roleName: 'भूमिका का नाम',
        roleDescription: 'भूमिका विवरण',
        roleType: 'भूमिका प्रकार',
        resource: 'संसाधन',
        action: 'कार्रवाई',
        enterRoleCode: 'भूमिका कोड दर्ज करें',
        enterRoleName: 'भूमिका का नाम दर्ज करें',
        enterRoleDescription: 'भूमिका विवरण दर्ज करें',
        selectResource: 'संसाधन चुनें',
        selectAllResource: 'सभी संसाधन चुनें',
        submit: 'जमा करें',
        update: 'अपडेट करें'
      },
      adminUser: {
        title: 'उपयोगकर्ता',
        userList: 'उपयोगकर्ता सूची',
        createUser: 'उपयोगकर्ता बनाएं',
        filterPlaceholder: 'फ़िल्टर',
        mapUser: 'उपयोगकर्ता मैप करें',
        userId: 'उपयोगकर्ता आईडी',
        userName: 'उपयोगकर्ता का नाम',
        phoneNo: 'फोन नंबर',
        email: 'ईमेल',
        roleDescription: 'भूमिका विवरण',
        action: 'कार्रवाई',
        delete: 'हटाएं',
        openList: 'सूची खोलें',
        selectUser: 'उपयोगकर्ता चुनें :',
        selectRole: 'भूमिका चुनें :',
        submit: 'सबमिट करें',
        enterEmail: 'ईमेल दर्ज करें :',
        enterPassword: 'पासवर्ड दर्ज करें :',
        enterConfirmPassword: 'पासवर्ड की पुष्टि करें :',
        selectUserPlaceholder: 'उपयोगकर्ता चुनें',
        selectRolePlaceholder: 'भूमिका चुनें',
        enterEmailPlaceholder: 'ईमेल दर्ज करें',
        enterPasswordPlaceholder: 'पासवर्ड दर्ज करें',
        enterConfirmPasswordPlaceholder: 'पासवर्ड की पुष्टि करें',
        enterPhoneNumber: 'फ़ोन नंबर दर्ज करें :',
        enterPhoneNumberPlaceholder: 'फ़ोन नंबर दर्ज करें',
        update: 'अपडेट',
        allRoles: 'सभी भूमिकाएँ',
        sNo: 'क्रम सं.',
        close: 'बंद करें',
        enterValidMobile: 'कृपया मान्य मोबाइल नंबर दर्ज करें',
        mobileRecordNotFound: 'इस मोबाइल नंबर का रिकॉर्ड नहीं मिला',
        userAlreadyExists: 'यह उपयोगकर्ता पहले से मौजूद है।',
        errorWhileGettingLE: 'वर्तमान कानूनी इकाई प्राप्त करते समय त्रुटि',
        selectRoleError: 'कृपया भूमिका चुनें'
      },
      adminUserManagement: {
        title: 'उपयोगकर्ता प्रबंधन',
        backToList: 'सूची पर वापस जाएं',
        addNewUser: 'नया उपयोगकर्ता जोड़ें',
        createEmployee: 'कर्मचारी बनाएं',
        updateEmployeeId: 'कर्मचारी आईडी अपडेट करें',
        selectEmployeeActiveStatus: 'कर्मचारी सक्रिय स्थिति चुनें',
        searchPlaceholder: 'खोजें',
        srNo: 'क्रम सं.',
        name: 'नाम',
        role: 'भूमिका',
        contact: 'संपर्क',
        department: 'विभाग',
        status: 'स्थिति',
        actions: 'कार्रवाई',
        active: 'सक्रिय',
        inactive: 'निष्क्रिय',
        allUsers: 'सभी उपयोगकर्ता',
        searchUsers: 'उपयोगकर्ता खोजें...',
        viewMore: 'और देखें',
        organization: 'संगठन',
        employeeDetails: 'कर्मचारी विवरण',
        employeeDetailsSubtitle: 'कर्मचारी के बारे में पूरी जानकारी',
        employeeName: 'कर्मचारी का नाम',
        phoneNumber: 'फ़ोन नंबर',
        dob: 'जन्म तिथि',
        showing: 'दिखा रहे हैं',
        users: 'उपयोगकर्ता',
        of: 'में से',
        enterMobile: 'मोबाइल नंबर दर्ज करें:',
        search: 'खोजें',
        cancel: 'रद्द करें',
        next: 'अगला',
        back: 'वापस',
        identity: 'पहचान',
        personInfo: 'कर्मचारी की जानकारी',
        personId: 'कर्मचारी आईडी:',
        systemAssigned: 'सिस्टम द्वारा निर्दिष्ट',
        personName: 'कर्मचारी का नाम:',
        personNameRequired: 'कर्मचारी का नाम आवश्यक है',
        email: 'ईमेल:',
        emailRequired: 'ईमेल आवश्यक है',
        validEmail: 'ईमेल मान्य है',
        enterValidEmail: 'मान्य ईमेल दर्ज करें',
        phone: 'फ़ोन:',
        phoneRequired: 'फ़ोन नंबर आवश्यक है',
        personDob: 'कर्मचारी की जन्म तिथि:',
        dobRequired: 'जन्म तिथि आवश्यक है',
        assignment: 'असाइनमेंट',
        employeeInfo: 'कर्मचारी जानकारी',
        employeeId: 'कर्मचारी आईडी',
        enterEmployeeId: 'कर्मचारी आईडी दर्ज करें',
        employeeIdRequired: 'कर्मचारी आईडी आवश्यक है',
        selectRole: 'भूमिका चुनें',
        roleRequired: 'भूमिका चयन आवश्यक है',
        selectDepartment: 'विभाग चुनें',
        departmentRequired: 'विभाग आवश्यक है',
        functionalArea: 'कार्यात्मक क्षेत्र',
        functionalAreaRequired: 'कार्यात्मक क्षेत्र आवश्यक है',
        selectHierarchy: 'संगठन पदानुक्रम चुनें',
        selectHierarchyBtn: 'पदानुक्रम चुनें',
        hierarchyRequired: 'पदानुक्रम चयन आवश्यक है',
        selectedHierarchyPath: 'चयनित पदानुक्रम पथ:',
        done: 'पूर्ण',
        selectedRole: 'चयनित भूमिका:',
        selectedDepartment: 'चयनित विभाग:',
        submit: 'सबमिट करें',
        currentlyEmployeeId: 'वर्तमान कर्मचारी आईडी:',
        newEmployeeId: 'नई कर्मचारी आईडी:',
        enterNewEmployeeId: 'नई कर्मचारी आईडी दर्ज करें',
         duplicateEmployeeError: 'खोजे गए ईमेल या फोन नंबर वाला कर्मचारी पहले से मौजूद है, कृपया नया कर्मचारी जोड़ने के लिए अलग ईमेल और फोन नंबर से खोजें।',
         userName: 'उपयोगकर्ता का नाम',
         organizationHierarchy: 'संगठन पदानुक्रम',
         assign: 'असाइन करें',
         close: 'बंद करें',
         instructions: 'निर्देश',
         instruction1: 'ड्रॉपडाउन से पदानुक्रम स्तरों का चयन करें।',
         instruction2: 'वर्तमान स्तर के नीचे एक नया स्तर जोड़ने के लिए नीचे तीर बटन पर क्लिक करें।',
         instruction3: 'पदानुक्रम से वर्तमान स्तर को हटाने के लिए ऊपर तीर बटन पर क्लिक करें।',
         instruction4: 'यदि कर्मचारी कई ज़ोन या वार्डों में काम कर रहा है, तो एक ज़ोन और एक वार्ड चुनें। कर्मचारी जोड़ने के बाद कई ज़ोन या वार्ड असाइन करने के लिए सूची पर जाएं और संपादित करें',
         instruction5: 'यदि कर्मचारी कई ज़ोन या वार्डों में काम कर रहा है तो असाइन बटन के माध्यम से जोड़ें।',
         currentHierarchyPath: 'वर्तमान पदानुक्रम पथ :',
         select: 'चुनें :',
         level: 'स्तर',
         warning: 'चेतावनी',
         fieldsCannotBeEmpty: 'फ़ील्ड खाली नहीं हो सकते',
         fieldsCannotBeNull: 'फ़ील्ड शून्य नहीं हो सकते',
         mobileOrEmailNull: 'मोबाइल नंबर या ईमेल शून्य नहीं हो सकता',
         invalidEmail: 'अमान्य ईमेल',
         mobileTenDigit: 'मोबाइल नंबर 10 अंकों में',
         enterValidCredential: 'कृपया मान्य क्रेडेंशियल दर्ज करें',
         enterValidLegalEntity: 'कृपया मान्य कानूनी इकाई दर्ज करें, संगठन नहीं..',
         personExistsWarning: 'खोजे गए ईमेल/फोन नंबर वाला व्यक्ति पहले से उपलब्ध है। इस व्यक्ति का विवरण निम्नलिखित है। यदि आप इस व्यक्ति को कर्मचारी के रूप में जोड़ना चाहते हैं तो आप "अगला" क्लिक करके जारी रख सकते हैं। यदि यह वह व्यक्ति नहीं है जिसे आप जोड़ना चाहते थे तो कृपया "वापस" क्लिक करें और अलग फोन और/या ईमेल का उपयोग करके खोजें।',
         noPersonFoundInfo: 'सिस्टम में खोजे गए ईमेल/फोन के साथ कोई व्यक्ति नहीं मिला। कृपया उस कर्मचारी के लिए पहचान बनाने के लिए विवरण भरें जिसे आप जोड़ना चाहते हैं',
         inactiveSuccess: 'सफलतापूर्वक निष्क्रिय किया गया',
         activeSuccess: 'सफलतापूर्वक सक्रिय किया गया',
         incorrectPhone: '...गलत फोन नंबर....!',
         areYouSure: 'क्या आप सुनिश्चित हैं?',
         yesAddIt: 'हां, इसे जोड़ें!',
         selectTwoLevel: 'कृपया कम से कम दो स्तर चुनें',
         empIdNotNull: 'कर्मचारी-आईडी शून्य नहीं होनी चाहिए!',
         empIdUpdated: 'कर्मचारी आईडी अपडेट की गई..!',
         assignmentUpdated: 'असाइनमेंट विवरण अपडेट किया गया..!',
         info: 'जानकारी'
      },
      adminZoneWordMapping: {
        title: 'जोन और वार्ड मैपिंग',
        addNewWard: 'नया वार्ड जोड़ें',
        addWardByExcel: 'एक्सेल द्वारा वार्ड जोड़ें',
        backToList: 'सूची पर वापस जाएं',
        wardMapping: 'वार्ड मैपिंग',
        searchPlaceholder: 'वार्ड खोजें',
        zone: 'जोन',
        ward: 'वार्ड',
        mohalla: 'मोहल्ला',
        actions: 'कार्रवाई'
      },
      officerDashboard: {
        title: 'डैशबोर्ड',
        totalComplaints: 'कुल शिकायतें',
        pending: 'लंबित',
        resolved: 'निस्तारित',
        escalated: 'एस्केलेटेड',
        awaitingAction: 'कार्रवाई की प्रतीक्षा',
        successfullyCompleted: 'सफलतापूर्वक पूरा हुआ',
        elevatedToHigherLevel: 'उच्च स्तर पर भेजा गया',
        forYourDepartment: 'आपके विभाग के लिए',
        search: 'खोजें',
        srNo: 'क्रम सं.',
        ticketId: 'टिकट आईडी',
        createdDate: 'शिकायत तिथि',
        recordsNotFound: 'रिकॉर्ड नहीं मिला !!',
        department: 'विभाग',
        fullName: 'पूरा नाम',
        mobileNo: 'मोबाइल नंबर'
      },
      officerComplaints: {
        closedTitle: 'बंद शिकायतें',
        escalatedTitle: 'एस्केलेटेड शिकायतें',
        pendingTitle: 'लंबित शिकायतें',
        resolvedTitle: 'निस्तारित शिकायतें',
        searchPlaceholder: 'खोजें',
        excel: 'एक्सेल',
        pdf: 'पीडीएफ',
        exportToExcel: 'एक्सेल में निर्यात करें',
        exportToPDF: 'पीडीएफ में निर्यात करें',
        srNo: 'क्रम सं.',
        ticketId: 'टिकट आईडी',
        department: 'विभाग',
        createdDate: 'शिकायत तिथि',
        zone: 'जोन',
        daysOpen: 'लंबित दिन',
        status: 'स्थिति',
        action: 'कार्रवाई',
        viewMore: 'और देखें',
        printForm: 'फॉर्म प्रिंट करें',
        recordsNotFound: 'रिकॉर्ड नहीं मिला !!',
        fullName: 'पूरा नाम',
        mobileNo: 'मोबाइल नंबर'
      },
      mcComplaints: {
        pendingTitle: 'लंबित शिकायतें',
        todayRegisteredTitle: 'आज पंजीकृत',
        totalTitle: 'कुल शिकायतें',
        searchPlaceholder: 'खोजें',
        excel: 'एक्सेल',
        pdf: 'पीडीएफ',
        exportToExcel: 'एक्सेल में निर्यात करें',
        exportToPDF: 'पीडीएफ में निर्यात करें',
        srNo: 'क्रम सं.',
        ticketId: 'टिकट आईडी',
        department: 'विभाग',
        createdDate: 'शिकायत तिथि',
        zone: 'जोन',
        daysOpen: 'लंबित दिन',
        status: 'स्थिति',
        action: 'कार्रवाई',
        viewMore: 'और देखें',
        printForm: 'फॉर्म प्रिंट करें',
        recordsNotFound: 'रिकॉर्ड नहीं मिला !!',
        fullName: 'पूरा नाम',
        mobileNo: 'मोबाइल नंबर'
      },
      officerSearchComplaints: {
        title: 'शिकायतें',
        searchPlaceholder: 'खोजें',
        id: 'आईडी',
        department: 'विभाग',
        dateTime: 'दिनांक और समय',
        zone: 'जोन'
      },
      officerUpdateComplaints: {
        back: 'वापस',
        ticketId: 'टिकट आईडी',
        filledOn: 'शिकायत की तारीख',
        updateStatus: 'स्थिति अपडेट करें',
        complaintsDetails: 'शिकायत विवरण',
        complaintsInformation: 'शिकायत जानकारी',
        reportedBy: 'शिकायत का विवरण जैसा कि शिकायतकर्ता द्वारा सूचित किया गया है',
        description: 'विवरण',
        department: 'विभाग',
        zone: 'जोन',
        citizenInformation: 'नागरिक जानकारी',
        contactNumber: 'संपर्क नंबर',
        contactCitizen: 'नागरिक से संपर्क करें',
        updateComplaintTitle: 'शिकायत की स्थिति अपडेट करें',
        reviewInstruction: 'शिकायतों की समीक्षा करें और इसकी स्थिति अपडेट करें।',
        remarksActionTaken: 'टिप्पणी/कार्रवाई की गई',
        uploadSupportingDoc: 'सहायक संलग्नक अपलोड करें (वैकल्पिक)',
        clickHereToView: 'देखने के लिए यहां क्लिक करें',
        updateComplaintBtn: 'शिकायत अपडेट करें',
        fillRequired: 'सभी आवश्यक फ़ील्ड भरें',
        resolved: 'निस्तारित',
        closed: 'बंद'
      },
      home: {
        welcome: 'लखनऊ नगर निगम समाधान दिवस पोर्टल में आपका स्वागत है'
      },
      preview: {
        ticketId: 'टिकट आईडी',
        fullName: 'पूरा नाम',
        mobileNo: 'मोबाइल नंबर',
        complaintDepartment: 'शिकायत विभाग',
        complaintType: 'शिकायत का प्रकार',
        complaintDescription: 'शिकायत का विवरण',
        zone: 'जोन',
        ward: 'वार्ड',
        mohalla: 'मोहल्ला',
        uploadedDocument: 'अपलोड किया गया संलग्नक',
        otherDocument: 'अन्य संलग्नक',
        instantResolutionDetails: 'तत्काल समाधान का विवरण',
        isInstantResolved: 'क्या तत्काल समाधान हुआ है',
        remark: 'टिप्पणी',
        approvalDescription: 'निस्तारण विवरण',
        othersDetails: 'अन्य विवरण',
        name: 'नाम',
        date: 'तारीख',
        document: 'संलग्नक',
        update: 'अपडेट',
        printForm: 'फॉर्म प्रिंट करें',
        printFormTitle: 'पीडीएफ में फॉर्म प्रिंट करें',
        registeredBy: 'दर्ज किया गया',
        pendingAt: 'लंबित है',
        closedBy: 'निस्तारित किया गया',
        resolvedBy: 'समाधान किया गया',
        noDocumentUploaded: 'कोई संलग्नक अपलोड नहीं हुआ!',
        uploadSuccess: 'अपलोड सफलतापूर्वक हो गया',
        uploadFailed: 'आपका अनुरोध पूरा नहीं हो पाया'
      },
      operatorDashboard: {
        title: 'डैशबोर्ड',
        totalComplaintRegistered: 'कुल दर्ज शिकायतें',
        addNewComplaints: 'नई शिकायत दर्ज करें',
        recentComplaints: 'हाल की शिकायतें',
        searchPlaceholder: 'खोजें',
        srNo: 'क्रम संख्या',
        ticketId: 'टिकट आईडी',
        department: 'विभाग',
        zone: 'जोन',
        ward: 'वार्ड',
        createDate: 'शिकायत तिथि',
        daysOpen: 'लंबित दिन',
        action: 'कार्रवाई',
        viewMore: 'और देखें',
        viewDetailedInfo: 'विस्तृत जानकारी देखें',
        moreOptions: 'अधिक विकल्प',
        printForm: 'फॉर्म प्रिंट करें',
        fullName: 'पूरा नाम',
        mobileNo: 'मोबाइल नंबर'
      },

      operatorNewComplaint: {
        back: 'वापस',
        submitComplaintTitle: 'शिकायत दर्ज करें',
        instruction: 'कृपया नीचे दिए गए फॉर्म में अपनी शिकायत का विवरण भरें।',
        fullName: 'पूरा नाम',
        enterFullName: 'पूरा नाम दर्ज करें',
        fullNameRequired: 'पूरा नाम आवश्यक है',
        fullNameInvalid: 'नाम स्पेस से शुरू नहीं हो सकता और इसमें नंबर/विशेष वर्ण नहीं होने चाहिए',
        fullNameMax: 'पूरा नाम 250 अक्षरों से अधिक नहीं हो सकता',
        mobileNumber: 'मोबाइल नंबर',
        enterMobileNo: 'मोबाइल नंबर दर्ज करें',
        mobileInvalid: 'कृपया 10 अंकों का मान्य मोबाइल नंबर दर्ज करें',
        complaintDepartment: 'शिकायत विभाग',
        selectDepartment: 'विभाग चुनें',
        departmentRequired: 'विभाग आवश्यक है',
        complaintType: 'शिकायत का प्रकार',
        selectComplaintType: 'शिकायत का प्रकार चुनें',
        complaintTypeRequired: 'शिकायत का प्रकार आवश्यक है',
        enterComplaintType: 'शिकायत का प्रकार दर्ज करें',
        complaintTypeNoLeadingSpace: 'शिकायत का प्रकार स्पेस से शुरू नहीं हो सकता',
        complaintDescription: 'शिकायत का विवरण',
        characters: 'अक्षर',
        complaintDescriptionPlaceholder: 'कृपया अपनी शिकायत का विवरण लिखें',
        descriptionRequired: 'विवरण आवश्यक है',
        descriptionMax: 'विवरण 500 अक्षरों से अधिक नहीं हो सकता',
        descriptionNoLeadingSpace: 'विवरण स्पेस से शुरू नहीं हो सकता',
        zone: 'जोन',
        select: 'चुनें',
        zoneRequired: 'जोन आवश्यक है',
        ward: 'वार्ड',
        firstSelectWard: 'पहले वार्ड चुनें',
        wardRequired: 'वार्ड आवश्यक है',
        officerName: 'अधिकारी का नाम',
        officerRequired: 'अधिकारी का नाम आवश्यक है',
        uploadDocumentOptional: 'संलग्नक अपलोड करें (वैकल्पिक)',
        clickHereToView: 'देखने के लिए यहां क्लिक करें',
        uploadNote: 'अपनी शिकायत से संबंधित 1 या अधिक संलग्नक अपलोड करें (अधिकतम 5MB)',
        otherDocumentOptional: 'अन्य संलग्नक (वैकल्पिक)',
        maxSize: '(अधिकतम 5MB)',
        instantResolutionDetails: 'तत्काल समाधान विवरण',
        markResolvedInstantly: 'तत्काल समाधान के रूप में चिह्नित करें',
        instantResolveNote1: 'यदि शिकायत का तुरंत समाधान हो गया है तो यहां टिक करें। अन्यथा समाधान का समय',
        hours: 'घंटे',
        days: 'दिन',
        remark: 'टिप्पणी',
        remarkPlaceholder: 'कृपया टिप्पणी दर्ज करें',
        remarkRequired: 'टिप्पणी आवश्यक है',
        remarkMax: 'टिप्पणी 500 अक्षरों से अधिक नहीं हो सकती',
        remarkNoLeadingSpace: 'टिप्पणी स्पेस से शुरू नहीं हो सकती',
        approvalDescription: 'निस्तारण विवरण',
        approvalRequired: 'निस्तारण विवरण आवश्यक है',
        approvalMax: 'निस्तारण विवरण 500 अक्षरों से अधिक नहीं हो सकता',
        approvalNoLeadingSpace: 'निस्तारण विवरण स्पेस से शुरू नहीं हो सकता',
        uploadImageOrDocumentOptional: 'संलग्नक अपलोड करें (वैकल्पिक)',
        submitComplaint: 'शिकायत दर्ज करें',
        fillRequiredFields: 'कृपया सभी आवश्यक फ़ील्ड भरें',
        markAtLeastOneDepartment: 'कम से कम एक विभाग चुनें',
        noOfficerMapped: 'इस विभाग या जोन में कोई अधिकारी मैप नहीं है',
        wardNotMapped: 'वार्ड मैप नहीं है',
        mohallaNotMapped: 'मोहल्ला मैप नहीं है',
        noDocumentUploaded: 'कोई संलग्नक अपलोड नहीं हुआ!'
      },
      operatorSuccessModal: {
        resolvedTitle: 'शिकायत का समाधान सफलतापूर्वक हो गया',
        resolvedText: 'मामला निस्तारित कर दिया गया है और संबंधित संलग्नक रिकॉर्ड में संलग्न हैं।',
        registeredTitle: 'शिकायत सफलतापूर्वक दर्ज हुई',
        ticketNo: 'टिकट नंबर',
        registeredText: 'जनरेट होकर संबंधित विभाग और अधिकारी को भेज दिया गया है'
      }
    }
  }
  constructor(private auth: AuthenticationService) {
    if (this.auth.language_cd) {
      this.language_cd = this.auth.language_cd
    }
  }
  setLanguage(language_cd: any) {
    this.language_cd = language_cd || 'HIN'
  }
  getLanguage() {
    return this.language_cd || 'HIN'
  }
  t(section: string, key: string) {
    const lang = this.language_cd || this.auth.language_cd || 'HIN'
    const sectionObj = this.translations[lang] && this.translations[lang][section]
    if (sectionObj && sectionObj[key]) {
      return sectionObj[key]
    }
    const fallback = this.translations['ENG'] && this.translations['ENG'][section]
    return (fallback && fallback[key]) || `${section}.${key}`
  }
}
